import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import ErrorPage from "../ErrorPage";

const Navigator = () => {
  const { filteredRoutes } = useSelector((state: any) => ({
    filteredRoutes: state.filteredRoutes,
  }));

  return (
    <Routes>
      {filteredRoutes.map((route) => (
        <Route
          key={route.key}
          path={route.path}
          element={<route.component />}
        />
      ))}
      {/* <Route path="/404" element={<ErrorPage />} /> */}
    </Routes>
  );
};

export default Navigator;
